export default __webpack_public_path__ + "static/media/confirmed-circle.3c5e7cc0.svg";